var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2H12C13.1046 2 14 2.89543 14 4V8H16V4C16 1.79086 14.2091 0 12 0H4C1.79086 0 0 1.79086 0 4V11.7143V13.7143H2H6V11.7143H2V4C2 2.89543 2.89543 2 4 2ZM10 14C10 12.8954 10.8954 12 12 12H20C21.1046 12 22 12.8954 22 14V21.7143H12C10.8954 21.7143 10 20.8189 10 19.7143V14ZM8 14C8 11.7909 9.79086 10 12 10H20C22.2091 10 24 11.7909 24 14V21.7143V23.7143H22H12C9.79086 23.7143 8 21.9234 8 19.7143V14ZM13.532 19.65L15.58 14.05H17.02L19.052 19.65H17.764L17.332 18.426H15.204L14.772 19.65H13.532ZM15.524 17.458H17.004L16.26 15.33L15.524 17.458ZM8.62012 3.5H7.37012V4.75H4.5V6H5.70829C6.01728 6.78848 6.46935 7.49631 7.03004 8.09582C6.39862 8.49908 5.67915 8.7716 4.91162 8.88125L5.0884 10.1187C6.15831 9.96584 7.15256 9.55654 8.00001 8.94794C8.84746 9.55654 9.84171 9.96584 10.9116 10.1187L11.0884 8.88125C10.3209 8.7716 9.6014 8.49908 8.96997 8.09582C9.53067 7.49631 9.98273 6.78848 10.2917 6H11.5V4.75H8.62012V3.5ZM8.00001 7.302C7.63206 6.92058 7.31932 6.48279 7.0759 6H8.92412C8.6807 6.48279 8.36796 6.92058 8.00001 7.302Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.4d70a0dac1f0bd6ee7290d0ec04da23e.svg";
export { ForwardRef as ReactComponent };